if (!window.__setsProductLoaded) {
  window.__setsProductLoaded = true;

  (function () {
    const originalFetch = window.fetch;
    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);
      const url = typeof arguments[0] === 'string'
        ? arguments[0]
        : (arguments[0] && arguments[0].url) || '';
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear')
      ) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
      return response;
    };
  })();

  class SetsProduct {
    constructor() {
      this.selectedVariants = {};
      this.bindEvents();
      this.checkCartStatus();
      this.updateCartCountOnLoad();
    }

    bindEvents() {
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.size-btn');
        if (!button) return;
        this.handleClick(button);
      });
      document.addEventListener('cart:updated', () => {
        this.checkCartStatus();
        this.updateCartCountOnLoad();
      });
    }

    handleClick(button) {
      const card = button.closest('.sets-product-card');
      if (!card) return;
      const container = card.closest('.set_section') || document;
      const cardsInContainer = Array.from(container.querySelectorAll('.sets-product-card'));
      const isLastCard = cardsInContainer.indexOf(card) === cardsInContainer.length - 1;
      const isQuickAdd = !!button.closest('quick-add-modal');
      const variantId = button.dataset.variantId;
      const productId = card.dataset.productId;

    //   if (button.classList.contains('in-cart')) {
    //     this.removeFromCart(variantId, productId);
    //   } else {
    //     this.addToCart(variantId, productId, isLastCard, isQuickAdd);
    //   }
    // }

  if (button.classList.contains('in-cart')) {
  this.removeFromCart(variantId, productId);
  return;
}

this.selectedVariants[productId] = {
  variantId,
  button
};

// this.showStatus(
//   productId,
//   'Selected. Please choose the other item.',
//   'adding'
// );

const selectedCount = Object.keys(this.selectedVariants).length;
const totalProducts = cardsInContainer.length;

if (selectedCount < totalProducts) {

  this.showStatus(
    productId,
    'Selected. Please choose the other item.',
    'adding'
  );

} else {

  this.showStatus(
    productId,
    'Both items selected. Adding to cart...',
    'adding'
  );

  this.addSelectedProducts(cardsInContainer, isQuickAdd);
}

// const selectedCount = Object.keys(this.selectedVariants).length;
// const totalProducts = cardsInContainer.length;

// if (selectedCount === totalProducts) {
//   this.addSelectedProducts(cardsInContainer, isQuickAdd);
// }
    }
    async addToCart(variantId, productId, openDrawer, isQuickAdd) {
      this.showStatus(productId, 'Adding...', 'adding');
      try {
        const quickAddNotification = isQuickAdd ? document.querySelector('quick-add-notification') : null;
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: quickAddNotification ? 'cart-drawer,cart-icon-bubble' : 'cart-drawer',
            sections_url: window.location.pathname
          })
        });
        const cart = await response.json();
        this.showStatus(productId, 'Added to cart', 'added');
        this.updateCartUI(cart);
        if (quickAddNotification) {
          quickAddNotification.renderContents(cart);
        } else if (openDrawer) {
          this.openCartDrawer();
        }
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        this.showStatus(productId, 'Error', 'error');
        console.error(err);
      }
      
    }
    async addSelectedProducts(cardsInContainer, isQuickAdd) {
  try {

    const items = cardsInContainer.map(card => {
      const productId = card.dataset.productId;

      return {
        id: this.selectedVariants[productId].variantId,
        quantity: 1
      };
    });

    const quickAddNotification = isQuickAdd
      ? document.querySelector('quick-add-notification')
      : null;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items,
        sections: quickAddNotification
          ? 'cart-drawer,cart-icon-bubble'
          : 'cart-drawer',
        sections_url: window.location.pathname
      })
    });

    const cart = await response.json();

    this.updateCartUI(cart);

    this.openCartDrawer();

    this.selectedVariants = {};

    document.dispatchEvent(
      new CustomEvent('cart:updated')
    );

  } catch (error) {
    console.error(error);
  }
}

    async removeFromCart(variantId, productId) {
      this.showStatus(productId, 'Removing...', 'adding');
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        const item = cart.items.find(i => i.variant_id == variantId);
        if (!item) return;
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: 'cart-drawer',
            sections_url: window.location.pathname
          })
        });
        const updatedCart = await response.json();
        this.showStatus(productId, 'Removed', 'removed');
        this.updateCartUI(updatedCart);
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } catch (err) {
        this.showStatus(productId, 'Error', 'error');
        console.error(err);
      }
    }

    updateCartUI(cart) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (cart.item_count > 0) {
          drawer.classList.remove('is-empty');
        } else {
          drawer.classList.add('is-empty');
        }
      }
      let countEls = document.querySelectorAll('.cart-count-bubble');
      if (!countEls.length) {
        const cartIcons = document.querySelectorAll('.header__icon--cart');
        cartIcons.forEach(icon => {
          const bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          icon.style.position = 'relative';
          icon.appendChild(bubble);
        });
        countEls = document.querySelectorAll('.cart-count-bubble');
      }
      countEls.forEach(el => {
        el.textContent = cart.item_count || 0;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      if (cart.sections && cart.sections['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cart.sections['cart-drawer'], 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
    }

    openCartDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.classList.add('active');
      drawer.classList.remove('is-empty');
      document.body.classList.add('overflow-hidden');
      const overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) {
        overlay.addEventListener('click', () => {
          drawer.classList.remove('active');
          document.body.classList.remove('overflow-hidden');
        });
      }
    }

    async checkCartStatus() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('.sets-product-card').forEach(card => {
          const productId = card.dataset.productId;
          const buttons = card.querySelectorAll('.size-btn');
          let totalQty = 0;
          buttons.forEach(button => {
            const variantId = parseInt(button.dataset.variantId);
            const item = cart.items.find(i => i.variant_id === variantId);
            if (item) {
              totalQty += item.quantity;
              this.setState(button, 'in-cart');
            } else {
              this.setState(button, 'available');
            }
          });
          if (totalQty > 0) {
            const text = totalQty > 1
              ? `Added to cart (${totalQty} sizes)`
              : `Added to cart`;
            this.showStatus(
              productId,
              `<span class="status-icon">
                <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                 <path d="M12.7078 4.29375C12.6151 4.2004 12.5048 4.12637 12.3833 4.07595C12.2618 4.02553 12.1315 3.99971 12 4H10V3.5C10 2.57174 9.63125 1.6815 8.97487 1.02513C8.3185 0.368749 7.42826 0 6.5 0C5.57174 0 4.6815 0.368749 4.02513 1.02513C3.36875 1.6815 3 2.57174 3 3.5V4H1C0.734784 4 0.48043 4.10536 0.292893 4.29289C0.105357 4.48043 0 4.73478 0 5V11.75C0 12.9688 1.03125 14 2.25 14H10.75C11.3395 14.0002 11.9057 13.7697 12.3275 13.3578C12.5398 13.1553 12.7088 12.9119 12.8244 12.6423C12.9399 12.3727 12.9997 12.0824 13 11.7891V5C13.0004 4.86881 12.9748 4.73884 12.9246 4.61761C12.8745 4.49638 12.8008 4.38631 12.7078 4.29375ZM8.89031 7.5625L6.09031 11.0625C6.04433 11.12 5.98623 11.1665 5.92017 11.199C5.85411 11.2314 5.7817 11.2488 5.70813 11.25H5.7C5.62778 11.25 5.55642 11.2344 5.49082 11.2042C5.42522 11.1739 5.36694 11.1299 5.32 11.075L4.12 9.6725C4.07732 9.6226 4.04489 9.56478 4.02455 9.50234C4.00422 9.43991 3.99638 9.37407 4.00149 9.30861C4.0066 9.24314 4.02455 9.17933 4.05432 9.1208C4.08409 9.06227 4.1251 9.01018 4.175 8.9675C4.2249 8.92482 4.28272 8.89239 4.34516 8.87205C4.4076 8.85172 4.47343 8.84388 4.53889 8.84899C4.60436 8.8541 4.66817 8.87205 4.7267 8.90182C4.78523 8.93159 4.83732 8.9726 4.88 9.0225L5.6875 9.96594L8.10969 6.9375C8.19257 6.8339 8.31321 6.76747 8.44507 6.75282C8.57693 6.73816 8.70921 6.77649 8.81281 6.85938C8.91641 6.94226 8.98285 7.0629 8.9975 7.19476C9.01215 7.32662 8.97382 7.4589 8.89094 7.5625H8.89031ZM9 4H4V3.5C4 2.83696 4.26339 2.20107 4.73223 1.73223C5.20107 1.26339 5.83696 1 6.5 1C7.16304 1 7.79893 1.26339 8.26777 1.73223C8.73661 2.20107 9 2.83696 9 3.5V4Z" fill="#1D3D72"/>
                </svg>
              </span>
              <span class="status-text">${text}</span>`,
              'added',
              true
            );
          } else {
            this.showStatus(productId, '', '');
          }
        });
      } catch (err) {
        console.error('Cart sync error:', err);
      }
    }

    setState(button, state) {
      button.classList.remove('available', 'in-cart', 'adding');
      button.classList.add(state);
    }

    showStatus(productId, text, type, persist = false) {
      const el = document.querySelector(
        `.cart-status[data-product-id="${productId}"] .status-message`
      );
      if (!el) return;
      el.className = 'status-message ' + type;
      el.innerHTML = text;
    }

    async updateCartCountOnLoad() {
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        this.updateCartUI(cart);
      } catch (err) {
        console.error(err);
      }
    }
  }

  const initSetsProduct = () => {
    if (window.__setsProductInstance) return;
    window.__setsProductInstance = new SetsProduct();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetsProduct);
  } else {
    initSetsProduct();
  }
}
